import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4.04104 7.13794H14M4.04104 11H14M1.01006 7.13794H1.02016M1.01006 11H1.02016M4.04104 3H14M1 3H1.0101" />
  </svg>
);
